import { CognitoUser as AWSCognitoUser } from '@aws-amplify/auth';
import { TWResponse } from './response.models';

export class User {
  username?: string;
  customerID?: string;
  customerBK?: string;
  cookieSettings?: { optIn: true } | null;
  preferredMFA?: 'NOMFA' | 'SOFTWARE_TOKEN_MFA';
}

export class UserResponse extends TWResponse {
  data: User;
}

// Workaround for issue https://github.com/aws-amplify/amplify-js/issues/3733
export type CognitoChallengeName = 'NEW_PASSWORD_REQUIRED' | 'SMS_MFA' | 'SOFTWARE_TOKEN_MFA' | 'MFA_SETUP';
export type CognitoUser = AWSCognitoUser & {
  challengeName: CognitoChallengeName;
  attributes?: Record<string, string>;
};

export interface AuthState {
  user?: CognitoUser | null;
  errors: {
    setInitialPasswordError?: Error;
    requestNewPasswordError?: Error;
    resetPasswordError?: Error;
    changePasswordError?: Error;
    loginError?: Error;
    mfaError?: Error;
  };
  mfa: {
    setupCode?: string;
  };
}

export class TokenInfo {
  idToken: string;
  accessToken: string;
  refreshToken: string;
}

export enum CustomUserTimezone {
  STORAGE_TIME = 'STORAGE_TIME',
  BROWSER_TIME = 'BROWSER_TIME',
  UTC = 'UTC',
}
